import { BusinessCard } from 'consumer-page-widgets/BusinessCard';
import { FunctionComponent } from 'react';
import { Typography } from 'omakase';
import { centerCropThumbnailUrl } from '@tock/images';
import { consumer } from '@tock/coretypes';
import { getAltTextWithFallback, getLocality } from 'utils/businessUtils';
import { oc } from 'ts-optchain';

interface AssociatedBusinessProps {
  business: consumer.RelatedBusiness;
}

const AssociatedBusiness: FunctionComponent<AssociatedBusinessProps> = ({ business }) => {
  const imageUrl = centerCropThumbnailUrl(business.profileImage?.[0]?.imageBackingUrl || undefined);
  const href = `/${business.domainName}`;
  return (
    <BusinessCard
      title={business.name}
      subtitle={
        <Typography component="span" variant="body02">
          {getLocality(business)}
        </Typography>
      }
      altText={getAltTextWithFallback(oc(business).profileImage[0].altText(), business)}
      dominantColor={oc(business).profileImage[0].dominantColor() || '#e9e9eb'}
      subtitleDetailed={getLocality(business)}
      image={imageUrl}
      href={href}
      showBody={false}
    />
  );
};

export default AssociatedBusiness;
